var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "carousel" }, [
    _vm.carouselHeading || _vm.arrows
      ? _c("div", { staticClass: "carousel__navigate" }, [
          _vm.carouselHeading
            ? _c("h2", { staticClass: "carousel__heading" }, [
                _vm._v(_vm._s(_vm.carouselHeading))
              ])
            : _vm._e(),
          _vm.arrows
            ? _c(
                "div",
                { staticClass: "carousel__arrows" },
                [
                  (_vm.infinite || _vm.currentSlideIndex !== 0) &&
                  _vm.slides.length > _vm.slidesToShow
                    ? _c(
                        "base-button",
                        {
                          staticClass:
                            "button--icon carousel__arrow carousel__arrow--previous",
                          attrs: { tabindex: "-1" },
                          on: {
                            click: function($event) {
                              return _vm.slidePrev()
                            }
                          }
                        },
                        [
                          _c("icon", {
                            staticClass: "carousel__arrow-icon",
                            attrs: {
                              name: "long-arrow-left",
                              height: "11px",
                              width: "32px"
                            }
                          }),
                          _c("span", { staticClass: "u-sr-only" }, [
                            _vm._v("Previous Slide")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  (_vm.infinite ||
                    _vm.currentSlideIndex !== _vm.slides.length - 1) &&
                  _vm.slides.length > _vm.slidesToShow
                    ? _c(
                        "base-button",
                        {
                          staticClass:
                            "button--icon carousel__arrow carousel__arrow--next",
                          attrs: { tabindex: "-1" },
                          on: {
                            click: function($event) {
                              return _vm.slideNext()
                            }
                          }
                        },
                        [
                          _c("icon", {
                            staticClass: "carousel__arrow-icon",
                            attrs: {
                              name: "long-arrow-right",
                              height: "11px",
                              width: "32px"
                            }
                          }),
                          _c("span", { staticClass: "u-sr-only" }, [
                            _vm._v("Next Slide")
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ])
      : _vm._e(),
    _c(
      "div",
      {
        directives: [
          {
            name: "touch",
            rawName: "v-touch:swipe.left",
            value: _vm.slideNext,
            expression: "slideNext",
            arg: "swipe",
            modifiers: { left: true }
          },
          {
            name: "touch",
            rawName: "v-touch:swipe.right",
            value: _vm.slidePrev,
            expression: "slidePrev",
            arg: "swipe",
            modifiers: { right: true }
          }
        ],
        ref: "carousel",
        staticClass: "carousel__carousel",
        style: _vm.carouselWidthStyles
      },
      [
        _vm.infinite
          ? _c(
              "div",
              {
                staticClass: "carousel__track carousel__track--clone",
                style: _vm.beforeTrackStyles
              },
              [_vm._t("clone-before")],
              2
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "carousel__track", style: _vm.trackStyles },
          [_vm._t("default")],
          2
        ),
        _vm.infinite
          ? _c(
              "div",
              {
                staticClass: "carousel__track carousel__track--clone",
                style: _vm.afterTrackStyles
              },
              [_vm._t("clone-after")],
              2
            )
          : _vm._e()
      ]
    ),
    _vm.dots
      ? _c(
          "ul",
          { staticClass: "carousel__dots u-list-simple u-list-inline" },
          _vm._l(_vm.slides.length, function(n) {
            return _c("li", { key: n }, [
              _c(
                "button",
                {
                  staticClass: "u-clear-button",
                  class: {
                    "is-active": n === _vm.currentSlideIndex + 1,
                    "carousel__dots-button": _vm.thumbnailImages.length === 0,
                    "carousel__dots-thumbnail": _vm.thumbnailImages.length > 0
                  },
                  on: {
                    click: function($event) {
                      return _vm.slideTo(n - 1)
                    }
                  }
                },
                [
                  _vm.thumbnailImages.length > 0
                    ? _c(
                        "div",
                        {
                          staticClass: "carousel__dots-thumbnail-image",
                          class: {
                            "carousel__dots-thumbnail-image--video": _vm.thumbnailImages[
                              n - 1
                            ].alt.includes("video")
                          }
                        },
                        [
                          _c("img", {
                            attrs: { src: _vm.thumbnailImages[n - 1].src }
                          }),
                          _vm.thumbnailImages[n - 1].alt.includes("video")
                            ? _c("icon", {
                                staticClass: "carousel__dots-thumbnail-icon",
                                attrs: { name: "play", size: "26px" }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "u-sr-only" }, [
                    _vm._v("Show Slide " + _vm._s(n))
                  ])
                ]
              )
            ])
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }